var render = function () {
  var _vm$vehicle$registrat, _vm$vehicle$registrat2, _vm$vehicle$registrat3, _vm$vehicle$registrat4, _vm$vehicle$registrat5, _vm$vehicle$registrat6, _vm$vehicle$registrat7, _vm$vehicle$registrat8;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "mx-4  mt-6",
    attrs: {
      "flat": "",
      "outlined": ""
    }
  }, [_c('v-card-text', [_c('NumberplateForm', {
    attrs: {
      "value": _vm.vehicle.numberplate || _vm.vehicle.displayName,
      "countryCode": _vm.partner.countryCode,
      "disabled": true
    }
  }), _vm.vehicle.identificationnumber ? _c('m-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": _vm.$t('objects.vehicle.identificationnumber'),
      "value": _vm.vehicle.identificationnumber,
      "readonly": "",
      "hide-details": ""
    }
  }) : _vm._e(), (_vm$vehicle$registrat = _vm.vehicle.registration) !== null && _vm$vehicle$registrat !== void 0 && _vm$vehicle$registrat.initialRegistrationDate ? _c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.vehicle.registration.initialRegistrationDate'),
      "value": (_vm$vehicle$registrat2 = _vm.vehicle.registration) === null || _vm$vehicle$registrat2 === void 0 ? void 0 : _vm$vehicle$registrat2.initialRegistrationDate,
      "readonly": "",
      "hide-details": ""
    }
  }) : _vm._e(), (_vm$vehicle$registrat3 = _vm.vehicle.registration) !== null && _vm$vehicle$registrat3 !== void 0 && _vm$vehicle$registrat3.manufacturerName ? _c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.vehicle.registration.manufacturerName'),
      "value": (_vm$vehicle$registrat4 = _vm.vehicle.registration) === null || _vm$vehicle$registrat4 === void 0 ? void 0 : _vm$vehicle$registrat4.manufacturerName,
      "readonly": "",
      "hide-details": ""
    }
  }) : _vm._e(), (_vm$vehicle$registrat5 = _vm.vehicle.registration) !== null && _vm$vehicle$registrat5 !== void 0 && _vm$vehicle$registrat5.manufacturerDescription ? _c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.vehicle.registration.manufacturerDescription'),
      "value": (_vm$vehicle$registrat6 = _vm.vehicle.registration) === null || _vm$vehicle$registrat6 === void 0 ? void 0 : _vm$vehicle$registrat6.manufacturerDescription,
      "readonly": "",
      "hide-details": ""
    }
  }) : _vm._e(), (_vm$vehicle$registrat7 = _vm.vehicle.registration) !== null && _vm$vehicle$registrat7 !== void 0 && _vm$vehicle$registrat7.manufacturerType ? _c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.vehicle.registration.manufacturerType'),
      "value": (_vm$vehicle$registrat8 = _vm.vehicle.registration) === null || _vm$vehicle$registrat8 === void 0 ? void 0 : _vm$vehicle$registrat8.manufacturerType,
      "readonly": "",
      "hide-details": ""
    }
  }) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }